export default __webpack_public_path__ + "static/media/guerreiro_overlap.72c7891a.mp3";